import { getResellersCustomerShiviom } from "../../http/shiviomHttp/ShiviomHttp";
// import ResellerCustomerList from "./ResellerCustomerList";
import { createPortal } from "react-dom";
import Div from "../Div";
import FormButton from "../FormButton";
import { useEffect, useCallback, useState } from "react";
import { Stack, Pagination } from "@mui/material"

function ResellerModal({ domain_name, handleClicked, ...props }) {

    const [customers, setCustomer] = useState(false)

    const getResellerCustomerShiviom = useCallback(async () => {
           const response = await getResellersCustomerShiviom(domain_name)
           setCustomer(response.customers)
          
       }, [domain_name])

    useEffect(() => {
        getResellerCustomerShiviom()
    }, [getResellerCustomerShiviom])

    function handleClose() {
        handleClicked(false);
    }

    const [currentPage, setCurrentPage] = useState(1);

    const itemsPerPage = 10;

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    const currentItems = customers ? customers.slice(indexOfFirstItem, indexOfLastItem) : null;

    // Calculate total pages
    const totalPages = customers ? Math.ceil(customers.length / itemsPerPage) : null;

    // Change page
    const paginate = (event, value) => {
        setCurrentPage(value);
    };


    return (
        <>
            {createPortal(
                <Div className="modal-backdrop">
                    <dialog {...props} style={{ zIndex: '1', width: '90%', marginTop: '5%' }}>

                        <Div className="form-group">Reseller Domain: {domain_name}</Div>

                       
                        { customers ?  <>
                                    <table className="table" border="1">
                                        <thead>
                                            <tr>
                                                <th>Customer Domain</th>
                                                <th>Customer Name </th>
                                                <th>Reseller Company Name</th>
                                                <th>Reseller Contact Number</th>
                                                <th>Reseller Email Id</th>
                                            </tr>
                                        </thead>
                                        <tbody id="tableBody">
                                            {currentItems.map((customer) =>
                                                <>
                                                    <tr key={customer.cust_id}>
                                                        <td>
                                                            {customer.domain_name}
                                                        </td>
                                                        <td>{customer.billing_contact_name}</td>
                                                        <td>{customer.billing_company_name}</td>
                                                        <td>{customer.billing_contact_number}</td>
                                                        {/* <td>{customer.licensed_seats}</td> */}
                                                        <td>{customer.reseller_email}</td>           
                                                    </tr>
                                                </>
                                               
                                            )

                                            }
                                        </tbody>
                                    </table>
                                    {customers.length > 0 ?
                                        <Stack spacing={2}>
                                            <Pagination count={totalPages} color="primary" page={currentPage} onChange={paginate}>

                                            </Pagination>

                                        </Stack> : null
                                    }
                                </>
                                : null

                        }

                        <Div className="form-group">
                            <Div className='row'>
                                <Div className='col-sm-2' style={{ marginTop: '15px' }}>
                                    <FormButton type='button' onClick={handleClose} style={{ margin: '2px' }} className="btn btn-primary submit-btn btn-block" >Close</FormButton>
                                </Div>
                            </Div>

                            <Div className='row'>
                                <Div className='col-sm-12'>
                                    {/* {error ?  <p style={{color:'red',marginLeft: '15px', marginTop:'4px'}}> {error}</p> : null } */}
                                </Div>
                            </Div>
                        </Div>

                    </dialog>

                </Div>
                , document.getElementById('modal'))

            }
        </>
    )
}

export default ResellerModal;